import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { getMenuData } from './menu.service.config'
import { BasicAuthService } from '../basic-auth.service'

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  constructor(private basicAuth: BasicAuthService) {}

  public getMenuData(): Observable<any[]> {
    return of(getMenuData(this.basicAuth.getConfig()))
  }
}
